import { useState } from "react";
import { useFormikContext } from "formik";
import { Collapse, IconButton, Paper, Stack, styled, Switch, Tooltip, Typography } from "@mui/material";
import get from "lodash/get";
import { ArrowDown01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { OrganizationSettings } from "@/types";

interface Props {
  title: string;
  description?: string;
  field: string;
  children: React.ReactNode;
}

const ExpandMore = styled(IconButton)(({ theme, expand }: { theme: any; expand: boolean }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const SettingsContainer = ({ title, description, field, children }: Props) => {
  const { values, setFieldValue } = useFormikContext<OrganizationSettings>();
  const [isExpanded, setIsExpanded] = useState(false);
  const isEnabled = get(values, `settings.services.${field}.isEnabled`, false);

  return (
    <Stack spacing={2}>
      <Paper sx={{ padding: 2 }}>
        <Stack spacing={{ xs: 3, md: 2 }} direction={{ md: "row" }} alignItems={"center"} justifyContent={"space-between"}>
          <Stack>
            <Typography variant="h4">{title}</Typography>
            {description ? (
              <Typography variant="body1" color="text.secondary">
                {description}
              </Typography>
            ) : null}
          </Stack>
          <Stack spacing={2} direction={"row"} alignItems={"center"} justifyContent={"flex-end"}>
            {isEnabled ? (
              <ExpandMore expand={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
                <Tooltip title={isExpanded ? "Contraer" : "Expandir"}>
                  <HugeiconsIcon icon={ArrowDown01Icon} />
                </Tooltip>
              </ExpandMore>
            ) : null}
            <Switch
              checked={isEnabled}
              onChange={(e: { target: { checked: boolean } }) => {
                setFieldValue(`settings.services.${field}.isEnabled`, e.target.checked);
              }}
            />
          </Stack>
        </Stack>

        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <Stack spacing={2} sx={{ marginTop: 2 }}>
            {children}
          </Stack>
        </Collapse>
      </Paper>
    </Stack>
  );
};
export default SettingsContainer;
